import type { WeekFlag, WbsFlatItem } from '../types';
import { buildWeightedValueMap } from './weeklyEvDisplay';

type ApprovedMap = Record<string, { approvedValue: number; sourceWeekOf: string }>;

export function resolveCurrentProvisionalEarnedValue(
    row: Pick<WbsFlatItem, 'id' | 'nodeId' | 'earnedValue'>,
    flags: Record<string, WeekFlag>,
    approvedMap: ApprovedMap,
    approvedMapW1: ApprovedMap,
): number | null {
    const confirmed = row.earnedValue ?? null;
    const fallbackApproved = approvedMap[row.nodeId]?.approvedValue ?? confirmed ?? null;
    const previousWeekApproved = approvedMapW1[row.nodeId]?.approvedValue ?? fallbackApproved;
    const flag = flags[row.id];
    const previousWeekEffective =
        flag?.previousWeekStatus === 'PENDING' || flag?.previousWeekStatus === 'APPROVED'
            ? (flag.previousWeekDraftEV ?? previousWeekApproved)
            : previousWeekApproved;

    if (!flag) return previousWeekApproved;
    if (flag.statusForWeek === 'APPROVED') return confirmed;
    if (flag.statusForWeek === 'PENDING') return flag.draftEV != null ? flag.draftEV : previousWeekEffective;
    if (flag.statusForWeek === 'REJECTED') return previousWeekEffective;
    if (flag.draftEV != null) return flag.draftEV;
    return previousWeekEffective;
}

export function resolveCurrentWeekDisplayLeafValue(
    row: Pick<WbsFlatItem, 'id' | 'nodeId' | 'earnedValue' | 'liveEarnedValue'>,
    flags: Record<string, WeekFlag>,
    approvedMapW1: ApprovedMap,
): number | null {
    const flag = flags[row.id];
    const previousWeekApproved = approvedMapW1[row.nodeId]?.approvedValue ?? row.earnedValue ?? null;
    const previousWeekEffective =
        flag?.previousWeekStatus === 'PENDING' || flag?.previousWeekStatus === 'APPROVED'
            ? (flag.previousWeekDraftEV ?? previousWeekApproved)
            : previousWeekApproved;

    return row.liveEarnedValue ?? flag?.liveEV ?? flag?.draftEV ?? previousWeekEffective;
}

export function buildCurrentWeekDisplayMap(
    rows: Array<Pick<WbsFlatItem, 'id' | 'nodeId' | 'earnedValue' | 'liveEarnedValue' | 'actualWeight' | 'weight' | 'parentId'>>,
    flags: Record<string, WeekFlag>,
    approvedMapW1: ApprovedMap,
): Record<string, number | null> {
    return buildWeightedValueMap(rows as WbsFlatItem[], (row) =>
        resolveCurrentWeekDisplayLeafValue(row, flags, approvedMapW1),
    );
}
